import { Phone, MessageCircle, MapPin } from "lucide-react";
import { telLink, waLink, business } from "@/config/business";

export default function MobileBar() {
  return (
    <nav
      aria-label="Quick actions"
      data-testid="mobile-cta-bar"
      className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white border-t border-primary/15 grid grid-cols-3"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        data-testid="mobile-bar-call"
        href={telLink}
        className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] text-primary text-xs font-semibold"
      >
        <Phone size={20} /> Call
      </a>
      <a
        data-testid="mobile-bar-whatsapp"
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] bg-wa text-white text-xs font-semibold"
      >
        <MessageCircle size={20} /> WhatsApp
      </a>
      <a
        data-testid="mobile-bar-directions"
        href={business.googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] text-primary text-xs font-semibold"
      >
        <MapPin size={20} /> Directions
      </a>
    </nav>
  );
}
